import React, { useState } from "react";
import Modal from "./Modal";
import { getLabelByValue, mainObjectives } from "../constants/formOptions";

function ModalRequestAssessment({ request, isOpen, onClose, onDone }) {
  const [assessments, setAssessments] = useState({});
  const [type, setType] = useState("InSar");

  const handleClose = () => {
    resetForm();
    onClose();
  };

  const handleDone = () => {
    const cleanedAssessments = Object.fromEntries(
      Object.entries(assessments).filter(
        ([_, values]) => values.some((val) => val.trim() !== "")
      )
    );
    
    onDone({ assessments: cleanedAssessments, type });
    handleClose();
  };

  const resetForm = () => {
    setAssessments({});
    setType("InSar");
  };

  const handleAssessmentChange = (category, index, value) => {
    setAssessments((prev) => ({
      ...prev,
      [category]: [
        ...(prev[category] || ["", "", ""]).map((val, i) => (i === index ? value : val)),
      ],
    }));
  };

  const renderSection = (category) => {
    const title = getLabelByValue(mainObjectives, category)
    const isEnabled = request.form?.selectedObjectives?.includes(category);
    const values = assessments[category] || ["", "", ""];

    return (
      <div
        className={isEnabled ? "" : "disabled"}
        style={{
          padding: 14,
          borderRadius: 10,
          backgroundColor: "#F2F3F4",
          display: "flex",
          marginBottom: 12,
        }}
      >
        <p style={{ width: "50%" }}>{title}</p>
        <div style={{ flexGrow: 1 }}>
          {[0, 1, 2].map((i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <span style={{ width: 150 }}>
                {i === 0 ? "First Suggestion *" : i === 1 ? "Second Suggestion" : "Third Suggestion"}
              </span>
              <input
                type="text"
                style={{ maxWidth: 300 }}
                disabled={!isEnabled}
                value={values[i]}
                onChange={(e) => handleAssessmentChange(category, i, e.target.value)}
              />
            </div>
          ))}
        </div>
      </div>
    );
  };

  if (!isOpen) return null;
  return (
    <Modal isOpen={isOpen} onClose={handleClose} className="large">
      <div className="modal-add-data-file">
        <h6>Preassessment Proposal</h6>
        Select the type of analysis
        <select
          onChange={(e) => setType(e.target.value)}
          style={{ marginLeft: 28, marginBottom: 30 }}
          value={type}
        >
          <option value="InSar">InSar</option>
        </select>

        {renderSection("evaluate")}
        {renderSection("assess")}
        {renderSection("context")}
      </div>

      <div className="modal-actions" style={{ justifyContent: "flex-end" }}>
        <button className="button-outline outline" onClick={handleClose}>
          Cancel
        </button>
        <button className="button-dark" onClick={handleDone}>
          Done
        </button>
      </div>
    </Modal>
  );
}

export default ModalRequestAssessment;
